import { getJson, sendJson, } from "../core/request";
import { profileWriteInvalidates } from "./keys";
export function readSection(api, spec, init) {
    return getJson(api, spec.path, spec.output, init);
}
export function writeSection(api, spec, input) {
    return sendJson(api, "PUT", spec.path, input, spec.output);
}
export function sectionOptions(api, spec) {
    return {
        queryFn: ({ signal }) => readSection(api, spec, { signal }),
        queryKey: spec.key,
    };
}
export function sectionMutation(api, spec) {
    return {
        invalidates: profileWriteInvalidates(spec.key),
        mutationFn: (input) => writeSection(api, spec, input),
        mutationKey: ["profile", spec.name, "put"],
    };
}
//# sourceMappingURL=section.js.map